import $ from 'jquery';
import 'bootstrap';

import preloader from './components/preloader.js';
import scrollProgress from './components/scrollProgress.js';
import shrinkNavigation from './components/shrinkNavigation';
import {addNavigationSpinnerEventListener} from './components/spinner';

import {initSwiper, initHeroSwiper, initSingleImageSwiper, initFullImageSwiper, initNewsSwiper} from './init/initSwiper.js';
import initModal from './init/initModal.js';
import initToasts from './init/initToasts.js';
import initArticleTools from './init/initArticleTools.js';
import initPrint from './init/initPrint.js';
import initColorModeToggle from './init/initColorModeToggle.js';
import initCaptionHeights from './init/initCaptionHeights';
import initDropdown from './init/initDropdown';
import initSearchField from './init/initSearchField';
import initSearchHighlight from './init/initSearchHighlight';
import {initScrollReveal} from './init/initScrollReveal';
import initMailLinks from './init/initMailLinks';
import initAudioPlayer from './init/initAudioPlayer';
import initBlockExtras from './init/initBlockExtras';
import {initJarallax} from './init/initJarallax';
import initHighlight from './init/initHighlight';
import initTabScroll from './init/initTabScroll';
import initListFilter from './init/initListFilter';
import initMap from './init/initMap';
import initMobileNav from './init/initMobileNav';
import initNaviGlide from './init/initNaviGlide';
import initImagePreview from './init/initImagePreview';
import initVideoConsent from './init/initVideoConsent';
import initSizeWarnings from './init/initSizeWarnings';
import initImageTilt from './init/initImageTilt';
import initAnchorNav from './init/initAnchorNav';
import initNavOverflow from './init/initNavOverflow';
import initSectionBridge from './init/initSectionBridge';
import initHeaderOverlay from './init/initHeaderOverlay';
import initFormErrorScroll from './init/initFormErrorScroll.js';

import 'animate.css';

import '../scss/app.scss';
import initLightbox from './init/initLightbox';

const App = function () {
    function handleBootstrap() {
        document.addEventListener('DOMContentLoaded', () => {
            $('.alert').alert();
        });
    }

    return {
        init: function () {
            handleBootstrap();
        }
    };
}();

$(function () {
    initImagePreview();
    initVideoConsent();
    initLightbox();
    initSizeWarnings();
    initImageTilt();
    App.init();
    preloader();
    scrollProgress();
    initJarallax();

    addNavigationSpinnerEventListener();
    shrinkNavigation();
    initHeaderOverlay();
    initHeroSwiper();
    initSwiper();
    initSingleImageSwiper();
    initFullImageSwiper();
    initNewsSwiper();
    initModal();
    initToasts();
    initArticleTools();
    initPrint();
    initColorModeToggle();
    initCaptionHeights();
    initDropdown();
    initSearchField();
    initSearchHighlight();
    initScrollReveal();
    initMailLinks();
    initAudioPlayer();
    initBlockExtras();
    initHighlight();
    initTabScroll();
    initListFilter();
    initMap();
    initMobileNav();
    initNavOverflow();
    initNaviGlide();
    initAnchorNav();
    initSectionBridge();
    // the stage page (template "infinity") only
    if (document.querySelector('[data-infinity]')) {
        import(/* webpackChunkName: "infinity" */ './init/initInfinity').then(({default: initInfinity}) => initInfinity());
    }
});

// registers its own DOMContentLoaded handler, so it stays outside of $(function () {});
initFormErrorScroll();